export const initialState = {
  users: [],
};
